import * as React from "react";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {UseState}       from "@Common/react/use-state";
import {getNestedValue} from "@Common/utils/arr-path";
import {chain}          from "@Common/utils/fs";

import {AddressSubSection}       from "../../../../../common/heavy/shipping-together-base/address-sub-section/address-sub-section";
import {ServiceLevelSubSection}  from "../../../../../common/heavy/shipping-together-base/service-level-sub-section/service-level-sub-section";
import {wrapSubmitting}          from "../../../../../common/wrap-submitting";
import {setShippingAddress}      from "../../store/actions/shipping/set-shipping-address";
import {setShippingServiceLevel} from "../../store/actions/shipping/set-shipping-service-level";
import {isFreightServiceLevel}   from "../common/is-freight-service-level";

export const ShippingTogether = ({addressData, store, apiError, autoCorrecting, next}) => cs(

    consumeContext("apis"),
    consumeContext("userLevels"),

    ["changingAddressId", (_, next) => UseState({next})],
    ["isInternalUser", ({userLevels}, next) => next(userLevels?.internalUser)],
    ["onChangeAddressId", ({apis, changingAddressId, isInternalUser}, next) => next((addressId) => cs(
        ({}, next) => wrapSubmitting(next, changingAddressId),
        async () => {
            try {
                await store.dispatch(setShippingAddress(addressId, {apis, apiError, isInternalUser}));
            } catch (e) {
                alert("Sorry we got an API error" + chain(e?.errors?.msg, (_) => _ ? ": " + _ : ""));
            }
        },
    ))],
    ["selectedAddressId", ({}, next) => next(getNestedValue(store, ["cart", "shipping", "addressId"]))],

    ["addressSubSection", ({changingAddressId, selectedAddressId, onChangeAddressId}, next) => AddressSubSection({
        addressData,
        onChangeAddressId,
        selectedAddressId,
        loading: changingAddressId.value || autoCorrecting,
        next,
    })],
    ["serviceLevelSubSection", (_, next) => ServiceLevelSubSection({next})],
    ({addressSubSection, selectedAddressId, apis, isInternalUser, serviceLevelSubSection}) => next({
        invalid: addressSubSection.invalid || !store.cart?.shipping?.isServiceLevelAvailableForAllItems,
        render: () => <>
            {addressSubSection.render({})}

            {serviceLevelSubSection.render({
                apiError: apiError.value,
                shippingItemsCount: store.cart.items.filter((i) => i.selections.distributionType === "shipping").length,
                selectedServiceLevel: store.cart.shipping?.serviceLevel,

                estimatedDeliveryMessage: !isFreightServiceLevel(store.cart.shipping?.serviceLevel) && (
                    store.cart?.shipping?.estimatedDeliveryMessage
                ),
                getServiceLevels: () => apis.next.shipping.getConsolidatedShippingRates({
                    addressId: selectedAddressId,
                    cartId: store.cart.cartId,
                    isInternalUser,
                }),

                onSelect: async (serviceLevel) => {
                    await store.dispatch(setShippingServiceLevel(serviceLevel, {apis}));
                },

                shippingCharge: {
                    value: (
                        store.cart.items.some((item) => item.shipping?.hasSubscriptionBenefit) ? (
                            0
                        ) : (
                            store.cart.shipping?.shippingCharge
                        )
                    ),
                },
                errors: [
                    store.cart?.shipping?.weightSurcharge && {
                        name: "surChargeInfo",
                        message: "Shipping weight exceeds 10 pounds, a weight surcharge has been added.",
                    },
                    !store.cart?.shipping?.isServiceLevelAvailableForAllItems && {
                        name: "serviceLevelError",
                        message: "The selected service level is not available for all orders in the cart. Please choose a different service level or select \"Split Shipping\" to apply separate selections for your orders.",
                    },
                ].filter(v=>v),
            })}
        </>,
    }),
);
